export const AppTexts = {

    //URL
    configURL: 'https://service.tangent.ai/shopify/get-config?shop_id=',
    responseURL: 'https://service.tangent.ai/shopify/responses',
    cacheFalse: '&cache=false',

    // JSON KEYS
    configJSONKEY: 'config',

    //FUNCTION KEYS
    uploadAndView : "upload_and_view", //To Upload image and view the uploaded image while API call
    openCamera : "open_camera",

    // Screen Names in json
    uploadScreen: "upload-view",

    //Primary Key Names
    functionName: "function_name", // Used as key for defining function for a button

    // CLASS NAMES 
    highlight_selection : "highlight-select",

    // Element types 
    multiOptionElement :"multi-option",
    customElement: 'custom',

    //COMMON
    response_id: 'resp_id',
    AiHighLightTextStyle:'ai_highlight_text_style',
    CheckBox: 'checkbox',
    MatLabel: 'mat-label',
    InputStyle : 'input-style',
    NextButton: 'next_button',
    Null: 'null',
    SelectionType: 'selection_type',
    SurveyOptionMobWidth: 'survey_option_mob_width',
    QuestionImage: 'question_img',
    Val: 'val',
    ScreenImage_1:'screen_image_1',
    OptionID: 'optID',
    OptionValue: 'optVal',
    OptionQuestion: 'optQst',
    QuestionID: 'qId',
    QuestionnName: 'qName',
    OptionImageStyle:'img_style',
    OptionStyle: 'opt_style',
    OptionTextStyle: 'text_style',
    OptionDataMap: 'api_data',
    NextQuestion: 'next_question',
    LoadScreen: 'load_screen',
    Type:'type',
    leftWelcomeScreenDiv :'left_welcome_screen_div',
    rightWelcomeScreenDiv :'right_welcome_screen_div',
    question: 'question',
    screen: 'screen',
    page: 'page',
    button: 'button',
    ButtonCategory: 'Button',
    clickEventName:'click',
    ClickAction:'Click',
    style : 'style'
}

export const CustomAppText = {

}

export const StyleKeys = {

    width: 'width',
    padding: 'padding',
    flexDirection: "flex-direction"

}


export const StyleValues = {

    block: 'block',
    none: 'none',
    row: 'row',
    column:'column',
    flex: 'flex',
    hundred_percentage: '100%'

}

export const TangentClassNames = {
    tangentGlobalStyle: 'tangent_global_style',
    tangentGlobalStyleCustom: 'tangent_global_style_custom',
    tangentPrimaryButton: 'tangent_primary_button',
    tangentPrimaryButtonCustom: 'tangent_primary_button_custom',
    tangentGlobalStyleMobCustom: 'tangent_global_style_mob_custom',
    tangentLoadingTextCustom: 'tangent_loading_text_custom',
    tangentLoadingTextMobCustom: 'tangent_loading_text_mob_custom',
    tangentQuizContainerCustom: 'tangent_quiz_container_custom',
    tangentQuizContainerMobCustom: 'tangent_quiz_container_mob_custom'
}

export const ScreenNames = {
    selfie: 'selfie',
    survey: 'survey',
    camera: 'camera'
}